import React, { useState, useEffect } from 'react';
import { Radio, Button, Space } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

const impactGroupAttributesConfig = [
  { label: 'None', key: 'None' },
  { label: 'Frequency & direction (binned)', key: 'frequencyAndDirectionBinned' },
  { label: 'What is the type of impact?', key: 'typeOfImpact' },
  { label: 'Whose P&L does this impact?', key: 'whosePandL' },
  {
    label: 'Actual impact update check (for last completed and previous periods)',
    key: 'actualImpactUpdateCheck',
  },
  { label: 'Created on', key: 'Created on' },
  { label: 'Year', key: 'Created on - Year', parentKey: 'Created on' },
  { label: 'Quarter', key: 'Created on - Quarter', parentKey: 'Created on' },
  { label: 'Month', key: 'Created on - Month', parentKey: 'Created on' },
  { label: 'Day', key: 'Created on - Day', parentKey: 'Created on' },
  { label: 'Year Week', key: 'Created on - YearWeek', parentKey: 'Created on' },
  { label: 'Week Day', key: 'Created on - Week Day', parentKey: 'Created on' },
  { label: 'Updated on', key: 'Updated on' },
  { label: 'Year', key: 'Updated on - Year', parentKey: 'Updated on' },
  { label: 'Quarter', key: 'Updated on - Quarter', parentKey: 'Updated on' },
  { label: 'Month', key: 'Updated on - Month', parentKey: 'Updated on' },
  { label: 'Day', key: 'Updated on - Day', parentKey: 'Updated on' },
  { label: 'Year Week', key: 'Updated on - YearWeek', parentKey: 'Updated on' },
  { label: 'Week Day', key: 'Updated on - Week Day', parentKey: 'Updated on' },
  { label: 'Total', key: 'total', group: 'Other' },
];

const ImpactGroupContent = ({ selectedGroup, setSelectedGroup }) => {
  const [showCreatedOnChildren, setShowCreatedOnChildren] = useState(false);
  const [showUpdatedOnChildren, setShowUpdatedOnChildren] = useState(false);

  const [isClearVisible, setIsClearVisible] = useState(false);

  const handleClear = () => {
    setSelectedGroup('None');
  };

  useEffect(() => {
    setIsClearVisible(selectedGroup !== 'None' && selectedGroup !== null);
  }, [selectedGroup]);

  useEffect(() => {
    setIsClearVisible(selectedGroup !== 'None');
    setShowCreatedOnChildren(selectedGroup === 'Created on');
    setShowUpdatedOnChildren(selectedGroup === 'Updated on');
  }, [selectedGroup]);

  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        {isClearVisible && (
          <Button
            type="text"
            onClick={handleClear}
            style={{ padding: 0, color: 'blue' }}
            icon={<CloseCircleOutlined />}
          >
            Clear
          </Button>
        )}
      </div>
      <Radio.Group value={selectedGroup} onChange={handleGroupChange}>
        {impactGroupAttributesConfig.map((attribute) => {
          const isParent = attribute.key === 'Created on' || attribute.key === 'Updated on';
          const isChild =
            attribute.parentKey === 'Created on' || attribute.parentKey === 'Updated on';

          if (isParent) {
            return (
              <div key={attribute.key}>
                <Radio value={attribute.key} style={{ display: 'block' }}>
                  {attribute.label}
                </Radio>
              </div>
            );
          }
          if (isChild) {
            return (
              <div key={attribute.key} style={{ marginLeft: '24px', marginBottom: '0' }}>
                <Radio value={attribute.key}>{attribute.label}</Radio>
              </div>
            );
          }

          // Render regular radio button
          return (
            <div key={attribute.key} style={{ marginBottom: '0' }}>
              <Radio value={attribute.key} style={{ display: 'block' }}>
                {attribute.label}
              </Radio>
            </div>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default ImpactGroupContent;
